import { useRouter } from 'next/router';

import { useAccountUIApiBasePath } from '../../provider';

export function useGetApiCacheKey(): (url: string) => string {
  const baseUrl = useAccountUIApiBasePath();
  const router = useRouter();
  const appBasePath = router?.basePath || '';

  return (url) => `${appBasePath}${baseUrl}${url}`;
}
